export const APP_ROUTES = {
  HOME: { route: '/' },
  CASE_STUDIES: {
    route: '/case-studies/:caseStudy',
    routeCreator: (caseStudy: string) => `/case-studies/${caseStudy}`,
  },
} as const;
